import script from "./UITemperatureIndicator.vue?vue&type=script&lang=ts&setup=true"
export * from "./UITemperatureIndicator.vue?vue&type=script&lang=ts&setup=true"

import "./UITemperatureIndicator.vue?vue&type=style&index=0&id=6909aeea&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6909aeea"]])

export default __exports__